/**
 * meta特殊参数说明： 【子路由会继承父路由的定义】
 * - index: number 路由切换动画的递进关系
 * - title: string 路由标题
 * - workbenchTitle: string 工作台标题
 * - pageType: private/public/protected   默认为private（登录后可展示），public（任何时候都可展示），protected（登录前可展示）
 * - layout：string 当前路由使用的布局
 */

import Vue from 'vue'
import VueRouter from 'vue-router'

import loginRoutes from './modules/login.js'
import personalCenterRoutes from './modules/personal-center.js'

Vue.use(VueRouter)

/**
 * 对定义的路由结构进行处理
 * 对于父路由没有component属性的，对该路由进行拍平处理
 */
function handleRouterList(routerList) {
  // 对路由进行解析
  const loop = (list, parent = {}) => {
    return list.map(router => {
      // 因为拍平路由，需要将父路由上的路径与子路由合并
      const parentPath = parent.path || ''
      if (parentPath && !router.path.startsWith(parentPath)) {
        router.path = `${parentPath}/${router.path}`
        router.path = router.path.replace(/\/+/g, '/')
      }
      // 子路由默认继承父路由的meta属性
      if (!router.meta) router.meta = {}
      router.meta = Object.assign({}, parent.meta || {}, router.meta)
      // 记录父子路由关系，目前使用场景为面包屑
      router.meta.breadcrumb = [
        ...(parent?.meta?.breadcrumb || []),
        { title: router?.meta?.title, name: router.name }
      ]

      if (router.children && (router.component || router?.meta?.keepParent)) {
        router.children = loop(router.children, router)
        return router
      } else if (router.children) {
        return loop(router.children, router)
      } else {
        return router
      }
    })
  }

  // 对路由解析过程中产生的多维数组进行拍平处理
  const routerListTemp = []
  const parseArrayLoop = list => {
    list.forEach(value => {
      if (Array.isArray(value)) {
        parseArrayLoop(value)
      } else {
        routerListTemp.push(value)
      }
    })
  }

  parseArrayLoop(loop(routerList))
  return routerListTemp
}

/**
 * 调用VueRouter
 * @type {VueRouter}
 */
const router = new VueRouter({
  mode: 'history',
  routes: handleRouterList([
    ...loginRoutes,

    // 个人中心路由配置
    ...personalCenterRoutes
  ])
})

export default router
